function returnOptions(data) {
  // 计算总和
  const arr = [];
  data.map((item) => arr.push(item.memberCount, item.noMemberCount));
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  return {
    color: ['#20a0ff', ' #fe6d6c', '#fdd451'],
    graphic: [{
      type: 'text',
      left: '27.5%',
      top: '58%',
      style: {
        text: '会员',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
        color: '#4d4f5c',
      }
    }, {
      type: 'text',
      left: '67.5%',
      top: '58%',
      style: {
        text: '散客',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
      }
    },
    ],
    title: {
      show: true,
      text: '顾客消费类型统计',
      subtext: `顾客总人数：${sum}`,
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    // 自定义提示框浮层
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} <br/>占比：{d}%'
    },
    series: [{
      type: 'pie',
      center: ['30%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },

      labelLine: {
        show: false
      },
      // 会员
      data: [
        { value: data[0].memberCount, name: '项目消费人数' },
        { value: data[1].memberCount, name: '产品消费人数' },
        { value: data[2].memberCount, name: '套餐消费人数' },
      ]
    },
    {
      type: 'pie',
      center: ['70%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },
      labelLine: {
        show: false
      },
      data: [
        { value: data[0].noMemberCount, name: '项目消费人数' },
        { value: data[1].noMemberCount, name: '产品消费人数' },
        { value: data[2].noMemberCount, name: '套餐消费人数' },
      ]
    },
    ]
  };
}
export const echartsB = returnOptions;
